import { ODSCardBasic, ODSButton, ODSText } from "@telekom-ods/react-ui-kit";
import classes from "./SuccessfulVerification.module.scss";

const UpdatedCard = ({ redirectUrl }) => (
	<ODSCardBasic
		actionSlot={
			<div className={classes.cardButtonContainer}>
				<ODSButton
					label="Jetzt vervollständigen"
					onClick={() =>
						(window.location.href =
							redirectUrl)
					}
					size="small"
					tabIndex="1"
				/>
			</div>
		}
		contentSlot={
			<>
				<ODSText as="h2" className={classes.cardHeader}>
					Telekom Login vervollständigen
				</ODSText>
				<ODSText as="pa" className="body m-0">
					Den Telekom Login benötigen Sie, um sich im Telekom Kundencenter und in der MeinMagenta App anzumelden.
Dort können Sie: Ihre Verträge und Rechnungen einsehen, persönliche Daten ändern und Ihre Aufträge nachverfolgen.
				</ODSText>
			</>
		}
		size="large"
	/>
);

export default UpdatedCard;
